/**
 * Plan §3.9 / §3.14 — after HARD_HELD + INITIATED payment, forbid cart/payable
 * mutations until the customer cancels payment first.
 */

export function isCustomerCheckoutCartLocked(input: {
  readonly awaitingPaymentOnServer: boolean;
  readonly hasActiveQrPayment: boolean;
  readonly hasActiveGatewayPayment?: boolean;
}): boolean {
  return (
    input.awaitingPaymentOnServer ||
    input.hasActiveQrPayment ||
    input.hasActiveGatewayPayment === true
  );
}
